import React from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import GroupIcon from '@mui/icons-material/Group';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import { Button } from '../../components/DetailsModal';
import { EventState } from '../../components/EventCell/types';
import { LessonEnrolment } from '../../services/classes/types';
import { EnrolmentType } from '../../types/common';

export const getStudentLessonState = (lesson: LessonEnrolment,
  makeUpButton: Button): EventState => {
  const attendedLessonState: EventState = {
    state: 'attended',
    status: {
      text: 'Attended',
      color: 'gray',
      icon: <TaskAltIcon fontSize="small" />,
    },
  };

  const absentLessonState: EventState = {
    state: 'absent',
    status: {
      text: 'Absent',
      color: 'error',
      icon: <ErrorOutlineIcon fontSize="small" />,
    },
  };

  const enrolledLessonState: EventState = {
    state: 'enrolled',
    buttons: [makeUpButton],
    status: {
      text: 'Enrolled',
      color: 'success',
      icon: <GroupIcon fontSize="small" />,
    },
  };
  const makeupLessonState: EventState = {
    state: 'makeup',
    buttons: [makeUpButton],
    status: {
      text: 'Makeup',
      color: 'warning',
      icon: <GroupIcon fontSize="small" />,
    },
  };

  // if the lesson roll is marked
  if (lesson.rollMarked) {
    if (lesson.present) {
      return attendedLessonState;
    }
    return absentLessonState;
  }

  if (lesson.enrolmentMethod === EnrolmentType.Makeup) {
    return makeupLessonState;
  }
  // if the lesson has yet to occur
  return enrolledLessonState;
};
